import PaySingleOutstandingSubscriptionPayment from '../components/SingleActionFlows/Subscriptions/PaySingleOutstandingSubscriptionPayment';

const Bookings = () => import(/* webpackPrefetch: true */ './../pages/Bookings');
const BookingDetail = () => import(/* webpackPrefetch: true */ './../pages/BookingDetail');
const OrderDetail = () => import(/* webpackPrefetch: true */ './../pages/OrderDetail');
const Communications = () => import('./../pages/Communications');
const Profile = () => import('./../pages/ProfilePage');
const ParentDetail = () => import('./../pages/ParentDetail');
const Child = () => import('./../pages/Child');
const Edit = () => import('./../pages/Edit');
const SavedCardsPage = () => import('./../pages/SavedCardsPage');
const SavedCardDetailPage = () => import('./../pages/SavedCardDetailPage');
const Avatar = () => import('./../pages/Avatar');
const Subscriptions = () => import('./../pages/SubscriptionsPage');
const SubscriptionDetail = () => import('./../pages/SubscriptionDetail');

export default [
  {
    path: '/parent',
    name: 'Home',
    component: Profile, // Home
    pathToRegexpOptions: { strict: true },
    meta: {
      title: 'Home',
      backRoute: null,
    },
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: Bookings,
    meta: {
      title: 'Bookings',
    },
  },
  {
    path: '/bookings/:clientId/:bookingId',
    name: 'BookingDetail',
    component: BookingDetail,
    meta: {
      title: 'Booking',
    },
  },

  {
    path: '/orders/:clientId/:orderId',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      title: 'Order',
    },
  },

  {
    path: '/communications',
    name: 'Communications',
    component: Communications,
    meta: {
      title: 'Inbox',
    },
  },
  // {
  //   path: '/profile',
  //   name: 'Profile',
  //   component: Profile,
  //   meta: {
  //     title: 'Profile'
  //   }
  // },
  {
    path: '/profile/:personId/child',
    name: 'Child',
    component: Child,
    meta: {
      title: 'Child',
      backRoute: 'Home',
    },
  },
  {
    path: '/profile/:personId/details',
    name: 'ParentDetail',
    component: ParentDetail,
    meta: {
      title: 'Profile',
      backRoute: 'Home',
    },
  },

  {
    path: '/profile/:personId/edit/:propertyName',
    name: 'Edit',
    component: Edit,
    meta: {
      title: 'Edit',
    },
  },
  {
    path: '/profile/saved-cards',
    name: 'SavedCardsPage',
    component: SavedCardsPage,
    meta: {
      title: 'Saved Cards',
      backRoute: 'Home',
    },
  },

  {
    path: '/profile/saved-cards/:cardId/detail',
    name: 'SavedCardDetailPage',
    component: SavedCardDetailPage,
    meta: {
      title: 'Detail',
      backRoute: 'SavedCardsPage',
    },
  },

  {
    path: '/profile/edit/avatar',
    name: 'Avatar',
    component: Avatar,
    meta: {
      title: 'Avatar',
    },
  },
  {
    path: '/profile/monthly-payments',
    name: 'Subscriptions',
    component: Subscriptions,
    meta: {
      title: 'Monthly Payments',
      backRoute: 'Home',
    },
  },
  {
    path: '/profile/monthly-payments/:clientId/detail',
    name: 'SubscriptionDetail',
    component: SubscriptionDetail,
    meta: {
      title: 'Payment Details',
      backRoute: 'Subscriptions',
    },
  },
  {
    path: '/page/outstanding-subscription',
    name: 'PaySingleOutstandingSubscriptionPayment',
    component: PaySingleOutstandingSubscriptionPayment,
    meta: {
      title: 'Failed Invoice',
      transitionName: 'slide',
      backRoute: -1,
    },
  },

];
